module.exports = __webpack_public_path__ + "static/media/Commercial-6.faf674aa.jpg";